// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import React from "react";
import { useTranslation } from "react-i18next";
import { Col, Form, Input, Row } from "antd";
import FormField from "../../../components/FormField";
import { NewsThemeLinkProps } from "../../../types/NewsThemeTypes";
import { FIELD_LENGTH } from "../../../../utils/Constant";

const NewsThemeLinkFormSection: React.FunctionComponent<NewsThemeLinkProps> = (
  props: NewsThemeLinkProps
) => {
  const { t } = useTranslation();

  const { index, editMode } = props;

  return (
    <>
      <Row>
        <Col xs={24} sm={12}>
          <FormField
            labelName={t("news_theme.link.title")}
            inputId={`link${index}Title`}
            emptyErrorMessage={t("global.empty_error_field")}
            readOnly={!editMode}
            maxLength={FIELD_LENGTH.NAME}
          />
        </Col>
        <Col xs={24} sm={12}>
          <FormField
            labelName={t("news_theme.link.url")}
            inputId={`link${index}Url`}
            emptyErrorMessage={t("global.empty_error_field")}
            readOnly={!editMode}
            type="url"
            maxLength={FIELD_LENGTH.URL}
          />
        </Col>
        <Col xs={24}>
          <Form.Item
            name={`link${index}Detail`}
            label={<span>{t("news_theme.link.details.label")}</span>}
          >
            <Input.TextArea
              id={`link${index}Details`}
              placeholder={
                editMode ? t("news_theme.link.details.placeholder") : ""
              }
              readOnly={!editMode}
              className={!editMode ? "readonly-textarea" : ""}
              maxLength={FIELD_LENGTH.DESCRIPTION}
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

NewsThemeLinkFormSection.defaultProps = {
  editMode: true
};

export default NewsThemeLinkFormSection;
